/* eslint-disable no-nested-ternary */
import * as React from 'react';
import { Text, Flex, Button } from '@chakra-ui/react';

import {
  UploadActions,
  UploadButtonSection,
  UploadComplete as UploadCompleteSection,
  AcknowledgeBox,
  RadioOptionsWithConfirm,
  IQuestion,
  Modal
} from 'shared-components';

import { ScholarshipDoc } from '../../../../../types';

export interface IProps {
  sectionTitle: string | undefined;
  fileNames: string[];
  document: ScholarshipDoc;
  onContinue: () => void;
  onUpload: (metaData: any) => void;
  onSaveMetaDataForNoDoc: (metadata?: any) => void;
  onClose: () => void;
  docKey: string;
  infoOnly: boolean;
  docStatus: string;
  onAcknowledgeToggle: (status: string) => void;
}
interface IState {
  questionsComplete: boolean;
  documentationType: string;
}
class ScholarshipSponsorModal extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    const { documentationType } = props.document;
    const questionsComplete = documentationType !== undefined;
    this.state = {
      questionsComplete: questionsComplete,
      documentationType: documentationType || ''
    };
  }

  onQuestionButtonClick = (question: IQuestion, stateName: string) => {
    this.setState(prevState => ({
      ...prevState,
      [stateName]: question.label,
      questionsComplete: false
    }));
  };

  onContinueClick = () => {
    const { documentationType } = this.state;
    const metaData = {
      documentationType
    };
    if (['Email from university', 'In my offer letter'].includes(this.state.documentationType)) {
      this.props.onSaveMetaDataForNoDoc(metaData);
      this.props.onClose();
    } else {
      this.props.onUpload(metaData);
    }
  };

  handleOnClose = () => {
    if (this.props.docStatus === 'INFO_ONLY') {
      this.props.onAcknowledgeToggle('NOT_ACKNOWLEDGED');
    }
    this.props.onClose();
  };

  toggleAcknowledge = (key: string, value: boolean) => {
    // prevent call to API if previous call not yet complete
    if (
      (value === true && this.props.docStatus !== 'ACKNOWLEDGED') ||
      (value === false && this.props.docStatus === 'ACKNOWLEDGED')
    ) {
      this.props.onAcknowledgeToggle(value === true ? 'ACKNOWLEDGED' : 'NOT_ACKNOWLEDGED');
    }
  };

  render() {
    const { questionsComplete, documentationType } = this.state;
    const { onClose, sectionTitle, fileNames, infoOnly, docStatus, docKey } = this.props;

    const showQuestion = (!questionsComplete && this.props.docStatus === 'AWAITING') || documentationType;
    return (
      <Modal show={true} id={'organisationSponsor'} title={sectionTitle} onClose={this.handleOnClose} hideFooter>
        {infoOnly ? (
          <>
            <Text>
              During your visa application you may be required to provide a letter from your scholarship provider
              stating the details of your scholarship.
            </Text>

            <AcknowledgeBox
              id={docKey}
              blurb="Please confirm you have read and understand the above."
              isTicked={docStatus === 'ACKNOWLEDGED'}
              onChange={this.toggleAcknowledge}
            />

            <UploadActions
              label="Return to document upload"
              complete={docStatus === 'ACKNOWLEDGED'}
              onContinue={this.handleOnClose}
            />
          </>
        ) : (
          <>
            {showQuestion ? (
              <>
                <RadioOptionsWithConfirm
                  label="What form of documentation do you have for your scholarship?"
                  questions={[
                    {
                      char: '1',
                      label: 'Email from university',
                      selected: documentationType === 'Email from university'
                    },
                    {
                      char: '2',
                      label: 'Official Letter',
                      selected: documentationType === 'Official Letter'
                    },
                    {
                      char: '3',
                      label: 'In my offer letter',
                      selected: documentationType === 'In my offer letter'
                    },
                    {
                      char: '4',
                      label: 'Other',
                      selected: documentationType === 'Other'
                    }
                  ]}
                  onClick={(question: IQuestion) => this.onQuestionButtonClick(question, 'documentationType')}
                />

                <Flex justifyContent="end">
                  <Button
                    id="continue"
                    isDisabled={!documentationType}
                    onClick={this.onContinueClick}
                    variant="solid"
                    size="lg"
                  >
                    {['Email from university', 'In my offer letter'].includes(this.state.documentationType)
                      ? 'Finish'
                      : 'Continue'}
                  </Button>
                </Flex>
              </>
            ) : docStatus === 'AWAITING' ? (
              <>
                <UploadButtonSection onUpload={this.onContinueClick}>
                  Awaiting upload of <b>{sectionTitle}</b>
                </UploadButtonSection>

                <UploadActions complete={false} onContinue={onClose} />
              </>
            ) : (
              docStatus === 'APPROVED' && (
                <UploadCompleteSection
                  fileNames={fileNames}
                  onUpload={this.onContinueClick}
                  onContinue={this.props.onClose}
                />
              )
            )}

            {docStatus === 'UPLOADED_OK' &&
            !['Email from university', 'In my offer letter'].includes(this.state.documentationType) ? (
              <UploadCompleteSection
                fileNames={fileNames}
                onUpload={this.onContinueClick}
                onContinue={this.props.onClose}
              />
            ) : null}
          </>
        )}
      </Modal>
    );
  }
}

export default ScholarshipSponsorModal;
